import styled, { css } from 'styled-components';
import { size } from '../../layout/helpers';
import type { OperationsStateIconStates } from '../OperationStateIcon';

interface WrapperProps {
  $state?: OperationsStateIconStates;
}

export const Wrapper = styled.div<WrapperProps>`
  display: flex;
  flex-direction: column;
  gap: ${size(1.5)};

  ${({ $state }) =>
    $state === 'completed'
      ? css`
            --_step-state-bg: var(--c-semantic-success-500);
          `
      : $state === 'inProgress'
        ? css`
            --_step-state-bg: var(--c-semantic-warning-500);
          `
        : $state === 'problem'
          ? css`
            --_step-state-bg: var(--c-semantic-error-500);
          `
          : undefined}
`;

export const Header = styled.header`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: ${size(1.5)};
  font-size: ${(props) => props.theme.font.size.small};
`;

export const Title = styled.div`
  display: flex;
  align-items: center;
  gap: ${size(1)};
`;

export const LabelWrapper = styled.div``;

export const Label = styled.div`
  font-weight: var(--font-weight-medium);
`;

export const SubLabel = styled.div`
  color: var(--c-text-muted);
  font-size: ${(props) => props.theme.font.size.xsmall};
  line-height: ${(props) => props.theme.font.lineHeight.alt};
`;

export const Count = styled.div`
  color: var(--c-text-muted);
`;

export const Progress = styled.div`
  display: flex;
  gap: ${size(0.25)};
`;

interface StepProps {
  $filled: boolean;
}

export const Step = styled.div<StepProps>`
  display: block;
  width: 100%;
  height: ${size(1)};
  background-color: var(--_step-bg, var(--c-accent-bg));

  ${({ $filled }) =>
    $filled &&
    css`
      --_step-bg: var(--_step-state-bg, --c-semantic-success-500);
    `}

  &:first-child {
    border-top-left-radius: 100vmax;
    border-bottom-left-radius: 100vmax;
  }

  &:last-child {
    border-top-right-radius: 100vmax;
    border-bottom-right-radius: 100vmax;
  }
`;
